import * as Yup from "yup";

export const brokerValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  email: Yup.string().required("Email is required"),
  gmId: Yup.string().required("GmId is required"),
  crmId: Yup.string().required("CrmId is required"),
});
